var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Uploaded Files")]),_c('files-table',{attrs:{"files":_vm.files,"show-owner":true},on:{"delete":_vm.deleteFile}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }